import React from 'react';
import { RcFile } from 'antd/lib/upload';

import './index.less';

import { IngestionSourceParametersOutput, IngestionSourceParametersType } from '../../../../../../gamma-api';
import SourceSettings from '../SourceSettings';
import { FileTableStore, IFileTableItem } from '../FileTable';
import { SourceModalParametersStep } from '../SourceModal';
import { FormAPI } from '../../../../../types';

import { MAIN_CLASS_NAME } from './const';

export interface ISourceParametersProps {
  formRef: React.RefObject<FormAPI>;
  sourceLoading: boolean;
  step: SourceModalParametersStep;
  parameters: IngestionSourceParametersOutput;
  files: IFileTableItem[];
  onChange?: (parameters: IngestionSourceParametersOutput) => void;
  onFileCreate?: (files: RcFile[], store: FileTableStore) => Promise<void>;
  onFileDelete?: (files: IFileTableItem[], store: FileTableStore) => Promise<void>;
}

const SourceParameters: React.FC<ISourceParametersProps> = ({
  formRef,
  sourceLoading,
  step,
  parameters,
  files,
  onChange,
  onFileCreate,
  onFileDelete,
}) => {
  const renderSettings = () => {
    if (parameters.type === IngestionSourceParametersType.Website) {
      return <SourceSettings.Website ref={formRef} parameters={parameters} onChange={onChange} />;
    }

    if (parameters.type === IngestionSourceParametersType.File) {
      return (
        <SourceSettings.File
          ref={formRef}
          files={files}
          loading={sourceLoading}
          parameters={parameters}
          onChange={onChange}
          onFileCreate={onFileCreate}
          onFileDelete={onFileDelete}
        />
      );
    }

    if (parameters.type === IngestionSourceParametersType.Confluence) {
      return <SourceSettings.Confluence ref={formRef} parameters={parameters} onChange={onChange} />;
    }

    if (parameters.type === IngestionSourceParametersType.Elma365) {
      return <SourceSettings.ELMA365 formRef={formRef} parameters={parameters} step={step} onChange={onChange} />;
    }

    return null;
  };

  return <div className={MAIN_CLASS_NAME}>{renderSettings()}</div>;
};

export default SourceParameters;
